import { useGlobalCache } from 'client/utils/useGlobalCache';
import { useEditor } from 'client/widget-components';
import { useEffect, useState } from 'react';
import fetchFacets from './utils/fetchFacets';
import { FilterableField } from './utils/types';

const useFilterableFieldsWithFacets = (
    filterableFields: FilterableField[]
) => {
    const [isLoading, setIsLoading] = useState(true);
    const [fields, setFields] = useState<FilterableField[]>([]);
    const globalCache = useGlobalCache();
    const { isInPreviewOrEditor } = useEditor();

    useEffect(() => {
        const queryKey = ['filterable-fields', filterableFields];
        const cachedFilterableFields =
            globalCache.get<FilterableField[]>(queryKey);

        if (cachedFilterableFields) {
            setFields(cachedFilterableFields);
            setIsLoading(false);
            return;
        }

        fetchFacets(filterableFields).then((enhancedFilterableFields) => {
            // only cache in runtime
            if (!isInPreviewOrEditor()) {
                globalCache.set(queryKey, enhancedFilterableFields);
            }
            setFields(enhancedFilterableFields);
            setIsLoading(false);
        });
        // on mount only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterableFields]);

    return { fields, isLoading };
};

export default useFilterableFieldsWithFacets;
